import "./Designs.scss";
import { Button, Drawer, Dropdown, Input, message, Tooltip } from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { DesignDto, LocationDto, MemberDto, MenuFolderDto } from "../../generated/dashboard-client";
import LocationsApi from "../../api/LocationsApi";
import DesignCard from "../design/DesignCard";
import { CreateFolderModal } from "../design/CreateFolderModal";
import DesignBatchBar from "../design/DesignBatchBar";
import { MoveToFolderModal } from "../design/MoveToFolderModal";
import { ConfirmDeleteModal } from "../design/ConfirmDeleteModal";
import DesignsLoading from "../design/DesignsLoading";
import { AppContext } from "../../AppContext";
import { ChangeLocationModal } from "../design/ChangeLocationModal";
import DesignCarousel from "../design/DesignCarousel";
import BrandTemplateCarousel from "../design/BrandTemplateCarousel";
import { DesignOption } from "../design/DesignCardMenu";
import { AllProducts } from "../../util/Products";
import DesignApi from "../../api/DesignApi";
import { isOldBrowser, getCookie, setExpandFoldersCookie, setDesignSortCookie } from "../../util/utils";
import { OldBrowserModal } from "../design/OldBrowserModal";
import { FolderButton } from "../design/FolderButton";
import { DeleteFolderModal } from "../design/DeleteFolderModal";
import { RemoveDesignFromFolderModal } from "../design/RemoveDesignFromFolderModal";
import { SearchOutlined, PlusOutlined, DownOutlined, UpOutlined, RightOutlined, EditOutlined, FolderOutlined } from "@ant-design/icons";
import { env } from "../../env/env";
import useFocus from "../../hooks/useFocus";
import CreateDesignModal from "../design/CreateDesignModal";
import CreateDesignMenuContent from "../design/CreateDesignMenuContent";
import { MoveToFolderDrawer } from "../design/MoveToFolderDrawer";
import { CreateFolderDrawer } from "../design/CreateFolderDrawer";
import {useLocation} from "react-router-dom";
import { DesignPageNavProps } from "../../util/types";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {cartState, memberState, mobileState, printProductionState} from "../../state/atoms";
import OrdersApi from "../../api/OrdersApi";
import { OrderDtoStatusEnum } from "../../generated/print-client";
// import PartnersCarousel from "../PartnersCarousel";
// import MenuDataSourceBanner from "../MenuDataSourceBanner";
import SortDesignsMenu from "../design/SortDesignsMenu";
import FilterDesignsMenu from "../design/FilterDesignsMenu";
import PopmenuWelcomeModal from "../design/PopmenuWelcomeModal";
//import DisplayBanner from "../design/DisplayBanner";
import { isProSubscription } from "../../service/BillingService";

interface DesignsProps {
  isSingleUserAcc: boolean;
  showPopmenuWelcomeModal: boolean;
  users: MemberDto[]
}

export interface FolderThumb {
  folderId: number,
  thumb: string
}

export enum SortOption {
  EditedRecent = "editedrecent",
  EditedRecentReverse = "editedreverse",
  NameAZ = "nameaz",
  NameZA = "nameza",
}

export default function Designs({ isSingleUserAcc, showPopmenuWelcomeModal, users }: DesignsProps) {
  const [isLoading, setLoading] = useState(true);
  const { location } = useContext(AppContext);

  const setPrintProduction = useSetRecoilState(printProductionState);
  const setCart = useSetRecoilState(cartState);
  const [searchKey, setSearchKey] = useState("");
  const [activeDesign, setActiveDesign] = useState({} as DesignDto);
  const [selected, setSelected] = useState([] as DesignDto[]);
  const [selectedIds, setSelectedIds] = useState([] as string[]);
  const [selectedPageCount, setSelectedPageCount] = useState(0);

  const [designs, setDesigns] = useState([] as DesignDto[]);
  const [folders, setFolders] = useState([] as MenuFolderDto[]);
  const [activeFolder, setActiveFolder] = useState(null as MenuFolderDto | null);
  const [isCreateFolderModal, setCreateFolderModal] = useState(false);
  const [isMoveToFolderModal, setMoveToFolderModal] = useState(false);
  const [isRemoveDesignFromFolderModal, setRemoveDesignFromFolderModal] =
    useState(false);
  const [isConfirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [isChangeLocationModal, setChangeLocationModal] = useState(false);
  const [isOldBrowserModal, setOldBrowserModal] = useState(false);
  const [isDeleteFolderModal, setDeleteFolderModal] = useState(false);
  const [isCreateDesignModal, setCreateDesignModal] = useState(false);
  const [isPopmenuWelcomeModal, setPopmenuWelcomeModal] = useState(showPopmenuWelcomeModal);
  const [hasSearchResults, setHasSearchResults] = useState(false);

  const [isCombineLoading, setCombineLoading] = useState(false);

  const [prevLocation, setPrevLocation] = useState({} as LocationDto);

  const [isFoldersExpanded, setIsFoldersExpanded] = useState(getCookie("expandFolders") === "false" ? false : true);
  const [folderToMove, setFolderToMove] = useState(null as MenuFolderDto | null);
  const [shownFolders, setShownFolders] = useState([] as MenuFolderDto[]);
  const [breadcrumbs, setBreadCrumbs] = useState([] as MenuFolderDto[]);
  const [folderThumbs, setFolderThumbs] = useState([] as FolderThumb[]);

  const [renameInputRef, setRenameInputFocus] = useFocus();
  const [isRenamingFolder, setIsRenamingFolder] = useState(false);
  const [folderName, setFolderName] = useState("");
  const mobile = useRecoilValue(mobileState);
  const routerLocation = useLocation();
  const member = useRecoilValue(memberState);

  const [hasBrandTemplates, setHasBrandTemplates] = useState(false);
  const isAdminOrOwner = member.owner || member.role === "Admin";
  const brandOnlyTeamUser =
    !isAdminOrOwner && member.templates && (member as any).manageBrand;
  const canSeeBrandCarousel = isAdminOrOwner || member.templates;
  const canSeeDesignCarousel = member.templates && !(brandOnlyTeamUser && hasBrandTemplates);

  const [isSortMenuOpen, setSortMenuOpen] = useState(false);
  const [currentSort, setCurrentSort] = useState(getCookie("designSort") as SortOption || SortOption.EditedRecent);
  const [isFilterMenuOpen, setFilterMenuOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState([] as string[]);

  const [hasUsers, setHasUsers] = useState(false);
  // const [viewMode, setViewMode] = useState<'card' | 'list'>('card');

  useEffect(() => {
    if (!routerLocation || !member.id) return;

    if ((routerLocation.state as DesignPageNavProps)?.showUpgradeModal) {
      window.MHM.ProModal.upgrade({memberId: member.id, onSuccess: () => window.location.href = env.basePath});
    }
  }, [routerLocation, member.id]);

  useEffect(() => {
    setSelectedIds(selected.map((it) => it.id!!));
  }, [selected]);

  useEffect(() => {
    let newShownFolders = folders.filter(fol => {
      if (!activeFolder && !fol.parentId) return true;
      if (activeFolder && parseInt(fol.parentId!) === activeFolder.id!) {
        return true;
      }
      return false;
    });
    setShownFolders([...newShownFolders]);
  }, [folders, activeFolder]);

  useEffect(() => {
    let newBreadcrumbs = [] as MenuFolderDto[];
    function recurseFolder(folder: MenuFolderDto | undefined) {
      if (folder) {
        let parent = undefined;
        folders.forEach(fol => {
          if (fol.id! === parseInt(folder.parentId!)) {
            parent = fol;
          }
        })
        if (parent) {
          newBreadcrumbs.unshift(parent);
          recurseFolder(parent);
        }
      }
    }
    if (activeFolder) {
      recurseFolder(activeFolder);
    }
    setBreadCrumbs([...newBreadcrumbs]);
  }, [activeFolder, folders])

  useEffect(() => {
    setHasUsers(users?.length > 0);
  }, [users.length]);

  const refreshFolderThumbs = useCallback((folders: MenuFolderDto[], designs: DesignDto[], folderId? : number, design? : DesignDto) => {
    if (folderId) {

    } else {
      let newThumbs = [] as FolderThumb[];
      folders.forEach(fol => {
        let firstDes = designs.find(des => {
          return des.folders?.includes(fol.id!.toString());
        });
        if (firstDes) {
          newThumbs.push({folderId: fol.id ?? 0, thumb: getDesignThumb(firstDes)});
        }
      })
      setFolderThumbs([...newThumbs]);
    }
  }, [])

  const ensureFolderCounts = useCallback((designs: DesignDto[], folders: MenuFolderDto[], lite: boolean = false) => {
    let folderCounts = {} as any;
    folders.forEach(fol => {
      folderCounts[fol.id!] = 0;

      folders.forEach(childFol => {
        if (childFol.parentId! === fol.id?.toString()) {
          folderCounts[fol.id] = folderCounts[fol.id] + 1;
        }
      });
    });

    designs.forEach(des => {
      if (des.folders) {
        if (!activeFolder) des.visible = false;

        let desFolders = [] as number[];
        folders.forEach(fol => {
          if (fol.id && des.folders!.includes(fol.id.toString())) {
            if (desFolders.length < 1) {
              folderCounts[fol.id] = folderCounts[fol.id] + 1;
            }
            desFolders.push(fol.id);
          }
        })
        if (!lite) {
          if (desFolders.length > 1) {
            des.folders = desFolders[0].toString();
            DesignApi.putInFolder([des.id!], desFolders[0]);
          } else if (desFolders.length === 0 && des.folders !== "") {
            console.log(`found design ${des.name} in nonexistent folder`);
            des.folders = "";
            DesignApi.removeFromFolder([des.id!]);
          }
        }
      } else {
        if (!activeFolder) des.visible = true;
      }
    })

    setDesigns(getSortedDesigns(designs, currentSort));

    folders.forEach(fol => {
      if (folderCounts[fol.id!] !== fol.count) {
        DesignApi.overrideFolderCount(fol.id!, folderCounts[fol.id!]).then(() => {
          fol.count = folderCounts[fol.id!];
          setFolders([...folders]);
        }).catch(() => {
          console.log('error changing folder count');
        })
      }
    })

    refreshFolderThumbs(folders, designs);
  }, [activeFolder, refreshFolderThumbs, currentSort])

  useEffect(() => {
    if (!location || !location.internalId) return;
    setPrevLocation(location);

    if (location.id !== prevLocation.id) {
      setLoading(true);
      LocationsApi.getLocationDesigns(location.internalId)
      .then(async ({ data }) => {
        const resp = await LocationsApi.getLocationFolders(
          location.internalId!
        );
        const alphaSortedFolders = resp.data.sort(function(a, b) {
          return ((a.name ?? "").replace(/\s/g, '')).localeCompare((b.name ?? "").replace(/\s/g, ''), 'en', { numeric: true });
        });
        setFolders(alphaSortedFolders);
        ensureFolderCounts(data, resp.data);

        const urlParams = new URLSearchParams(window.location.search);
        const urlFolderId = urlParams.get('folderId');
        if (urlFolderId) {
          const goToFolder = alphaSortedFolders.find(fol => { return fol.id === parseInt(urlFolderId) });
          if (goToFolder) {
            setIsFoldersExpanded(true);
            setFolderName(goToFolder.name!);
            data.forEach(
              (it) => (it.visible = (it.folders ?? "").indexOf(`${urlFolderId}`) > -1)
            );
            setActiveFolder(goToFolder);
          }
          let url = window.location.href.split('?')[0];
          if (window.history) {
              window.history.replaceState({}, '', url);
          }
        }

        setDesigns(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  }, [location, prevLocation.id, ensureFolderCounts, refreshFolderThumbs]);

  useEffect(() => {
    if (!location?.internalId) return;
    OrdersApi.getDraftOrder(location.internalId!).then((resp) => {
      if (resp.data) {
        let designsInCart = [] as string[];
        resp.data.items?.forEach(item => {
          designsInCart.push(item.designId!);
        })
        setCart({menus: designsInCart});
      }
    });
    OrdersApi.getLocationOrders(location.internalId!).then((resp) => {
      if (resp.data) {
        let designsInPrint = [] as string[];
        resp.data.forEach(order => {
          if (order.status === OrderDtoStatusEnum.Paid || order.status === OrderDtoStatusEnum.Processing || order.status === OrderDtoStatusEnum.Sent) {
            order.items?.forEach(item => {
              designsInPrint.push(item.designId!);
            })
          }
        })
        setPrintProduction({menus: designsInPrint});
      }
    });
  }, [location.internalId, setPrintProduction, setCart])

  useEffect(() => {
    setOldBrowserModal(isOldBrowser());
  }, []);

  function onFolderClick(folder: MenuFolderDto) {
    if (folder.id === activeFolder?.id) {
      return;
    }

    setIsFoldersExpanded(true);
    setFolderName(folder.name!);

    designs.forEach(
      (it) => (it.visible = (it.folders ?? "").indexOf(`${folder.id}`) > -1)
    );

    onCancelClick();
    setActiveFolder(folder);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setCurrentFilter([]);
  }

  function onDeleteFolderClick(folder: MenuFolderDto) {
    setFolderToMove(folder);
    setDeleteFolderModal(true);
  }

  function onMoveFolderToFolderClick(folder: MenuFolderDto) {
    setFolderToMove(folder);
    setMoveToFolderModal(true);
  }

  function clearFolder(scrollAfter = true) {
    designs.forEach((it) => {
      it.visible = (it.folders ?? "") === "";
    });
    onCancelClick();
    setDesigns([...designs]);
    setActiveFolder(null);
    setSearchKey("");
    setCurrentFilter([]);
    if (scrollAfter) {
      setTimeout(() => {
        scrollToFoldersTop();
      }, 50);
    }
  }

  function onSearch(key: string) {
    key = key.toLowerCase();
    let hasResults = false;
    designs.forEach((it) => {
      if (activeFolder) {
        if ((it.folders ?? "").indexOf(`${activeFolder.id}`) === -1) {
          it.visible = false;
          return;
        }
      }
      const name = it.name?.toLowerCase() ?? "";
      it.visible = name.indexOf(key) > -1;
      if (it.visible) {
        hasResults = true;
      }
    });
    setCurrentFilter([]);
    setDesigns([...designs]);
    setHasSearchResults(hasResults);
    setSearchKey(key);
  }

  function onDesignSelect(design: DesignDto, checked: boolean) {
    if (checked) {
      setSelected([...selected, design]);
      setSelectedPageCount(selectedPageCount + (design.pageCount || 0));
      setFolderToMove(null);
    } else {
      setSelected(selected.filter((it) => it.id !== design.id));
      setSelectedPageCount(selectedPageCount - (design.pageCount || 0));
    }
  }

  function onDesignUpdate(design: DesignDto) {
    const found = designs.find((it) => it.id === design.id);
    if (found) {
      found.name = design.name;
      found.inUse = design.inUse;
      found.inUseMemberId = design.inUseMemberId;
      found.inUseLastPingAt = design.inUseLastPingAt;
      setDesigns([...designs]);
    }
  }

  function onOrganizeClick() {
    setMoveToFolderModal(true);
  }

  function onDeleteClick() {
    setConfirmDeleteModal(true);
  }

  function onCombineClick() {
    setCombineLoading(true);
    let name = "Combined designs";
    const desNames = designs.map((des) => { return des.name });
    if (desNames.includes("Combined designs")) {
      let foundUniqueName = false;
      let count = 1;
      while (!foundUniqueName) {
        if (!desNames.includes(`Combined designs (${count})`)) {
          name = `Combined designs (${count})`;
          foundUniqueName = true;
        } else {
          count += 1;
        }
      }
    }

    DesignApi.merge(selectedIds, name)
    .then((resp) => {
      onCancelClick();
      reloadDesigns(resp.data);
      setCombineLoading(false);
      scrollToDesignsTop();
    })
    .catch((err) => {
      console.log("Error merging designs: " + err);
      message.error("Error merging designs");
      setCombineLoading(false);
    });

  }

  function scrollToDesignsTop() {
    let designsObj = document.getElementById('savedDesigns');
    if (designsObj) {
      window.scrollTo({top: designsObj.offsetTop - 15, behavior: "smooth"});
    }
  }

  function scrollToFoldersTop() {
    let designsObj = document.getElementsByClassName('saved-designs-content')[0] as HTMLElement;
    if (designsObj) {
      window.scrollTo({top: designsObj.offsetTop - 15, behavior: "smooth"});
    }
  }

  function onCancelClick() {
    setSelectedIds([]);
    setSelected([]);
    setSelectedPageCount(0);
    setFolderToMove(null);
  }

  function onConfirmDeleteModalClose(removed: boolean) {
    setConfirmDeleteModal(false);
    if (removed) {
      const filteredDesigns = designs.filter((it) => selectedIds.indexOf(it.id!!) === -1)
      setDesigns(filteredDesigns);
      ensureFolderCounts(filteredDesigns, folders, true);
    }
    onCancelClick();
  }

  function onChangeLocationModalClose(id: string, locationId: number, removed: boolean) {
    setChangeLocationModal(false);
    if (removed) {
      if (locationId !== location.internalId) {
        setDesigns(designs.filter((it) => it.id !== id));
      }
      ensureFolderCounts(designs.filter((it) => it.id !== id), folders, true);
    }
  }

  function onCreateFolderModalClose(ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto, parentFolder?: MenuFolderDto) {
    setCreateFolderModal(false);
    setMoveToFolderModal(false);

    if (folder) {
      folder.count = folder.count! + ids.length;
      if (folderToMove) {
        folders.forEach(fol => {
          if (fol.id! === folderToMove.id!) {
            folderToMove.parentId = folder.id?.toString();
          }
        })
      }
      if (parentFolder) {
        folder.parentId = parentFolder.id!.toString();
      }
      setFolders([folder, ...folders]);
      syncDesignsFolders(folder, [folder, ...folders], ids);
      setIsFoldersExpanded(true);
    }
    onCancelClick();
  }

  function onMoveToFolderClose(save: boolean, folder?: MenuFolderDto) {
    setMoveToFolderModal(false);
    if (save && (selected.length > 0 || selectedIds.length > 0)) {
      const count = selected.length || selectedIds.length;
      const label = count > 1 ? "Files" : "File";
      message.success(`${label} sucessfully moved`);

      if (folder) {
        syncDesignsFolders(folder, folders, selectedIds);
      }
    }
    onCancelClick();

    if (mobile) {
      closeAllDrawers();
    }
  }

  function onMoveToFolderSavedDesignsClose(designIds: string[]) {
    const count = selected.length || selectedIds.length;
    const label = count > 1 ? "Files" : "File";
    message.success(`${label} sucessfully moved`);

    setMoveToFolderModal(false);
    onRemoveDesignFromFolderSuccess(designIds);

    if (mobile) {
      closeAllDrawers();
    }
  }

  function onMoveToFolderMovedFolderClose(childFolderId: number, parentFolderId: string) {
    if (childFolderId) {
      message.success('Folder sucessfully moved');
      folders.forEach((fol) => {
        if (fol.id === childFolderId) {
          fol.parentId = parentFolderId;
        }
      })
      setFolders([...folders]);
      ensureFolderCounts(designs, [...folders], true);
    }
    setMoveToFolderModal(false);
    onCancelClick();

    if (mobile) {
      closeAllDrawers();
    }
  }

  function closeAllDrawers() {
    let drawers = document.querySelectorAll('.ant-drawer-open .ant-drawer-mask');
    drawers.forEach(drawer => {
      (drawer as HTMLElement).click();
    })
  }

  function syncDesignsFolders(folder: MenuFolderDto, folders: MenuFolderDto[], ids: string[]) {
    if (ids.length > 0) {
      designs.forEach((it) => {
        if (ids.indexOf(it.id!) > -1) {
          it.folders = folder.id!.toString();
          if (!activeFolder || activeFolder.id !== folder.id) {
            it.visible = false;
          }
        }
      });
      onCancelClick();
      setTimeout(() => {
        setDesigns([...designs]);
        ensureFolderCounts(designs, folders, true);
      }, 250);
    }
  }

  function onDesignOptionClick(design: DesignDto, option: DesignOption) {
    setActiveDesign(design);
    setSelectedIds([design.id!]);
    setFolderToMove(null);

    switch (option) {
      case DesignOption.ChangeLocation:
        setChangeLocationModal(true);
        break;
      case DesignOption.Delete:
        setConfirmDeleteModal(true);
        break;
      case DesignOption.MoveToFolder:
        setMoveToFolderModal(true);
        break;
      case DesignOption.RemoveFromFolder:
        setRemoveDesignFromFolderModal(true);
        break;
    }
  }

  function reloadDesigns(data: any) {
    const updated = [data, ...designs];
    setDesigns(updated);
    if (data.folders!) {
      ensureFolderCounts(updated, folders, true);
    }
  }

  function onCreateNewFolder() {
    setMoveToFolderModal(false);
    setCreateFolderModal(true);
  }

  function onRemoveDesignFromFolderSuccess(
    designIds: string[]
  ) {
    setRemoveDesignFromFolderModal(false);
    if (designIds.length) {
      designs.filter((it) => designIds.includes(it.id!)).forEach(des => {
        des.folders = "";
        des.visible = false;
      });
      onCancelClick();
      setTimeout(() => {
        setDesigns([...designs]);
        ensureFolderCounts(designs, folders, true);
      }, 250);
    }
  }

  function onDeleteFolderSuccess(removedFolderId: number) {
    setDeleteFolderModal(false);
    let newFolders = folders;
    if (removedFolderId) {
      newFolders = newFolders.filter((it) => it.id !== removedFolderId);
    }
    const designsInFolder = designs.filter((it) => ((it.folders ?? "").indexOf(`${removedFolderId}`) > -1));
    designsInFolder.forEach(des => des.folders = "");
    DesignApi.removeFromFolder(designsInFolder.map(des => des.id!));

    newFolders.forEach((fol) => {
      if (removedFolderId === parseInt(fol.parentId!)) {
        fol.parentId = "";
        DesignApi.removeFolderFromFolder(fol.id!);
      }
    })
    setFolders([...newFolders]);

    onCancelClick();
    ensureFolderCounts(designs, [...newFolders], true);
  }

  function toggleExpandFolders(expanded: boolean) {
    setIsFoldersExpanded(expanded);
    setExpandFoldersCookie(expanded);
  }

  function getDesignThumb(design: DesignDto, height: number = env.rendererImageHeight) {
    if (design.upload) {
      return `/imageservice/images/13/member/uploads/user_${design.id}/thumb_${design.id}1.jpg`;
    } else {
      return `${env.rendererPath}/design/thumbnail/${design.id}?height=${height}&update=1652086126000`;
    }
  }

  function folderNameExists(currentFolder: MenuFolderDto | null, potentialName: string) {
    let foldersToSearch = currentFolder ? folders.filter(fol => fol.id !== currentFolder.id) : folders;
    if (foldersToSearch.map(fol => fol.name ?? "").includes(potentialName)) {
      message.error(`You already have a folder named ${potentialName}`);
      return true;
    }
  }

  function renameFolder() {
    setIsRenamingFolder(false);
    if (!!folderName) {
      if (folderNameExists(activeFolder!, folderName)) {
        setFolderName(activeFolder?.name!);
      } else {
        LocationsApi.renameFolder(activeFolder?.id!, folderName)
        .then(() => {
          setFolderName(folderName);
          afterFolderRename(activeFolder!, folderName);
        })
        .catch((error) => {
          console.log("error renaming link page: " + error);
          setFolderName(activeFolder?.name ?? "");
        });
      }
    }
  }

  function afterFolderRename(folder: MenuFolderDto, name: string) {
    folders.forEach(fol => {
      if (fol.id === folder.id) {
        fol.name = name;
      }
    })
    setFolders([...folders]);
  }

  function startRenamingFolder(ev: React.MouseEvent<HTMLElement, MouseEvent>) {
    setIsRenamingFolder(true);
    (setRenameInputFocus as () => void)();
  }

  function getSortedDesigns(designs: DesignDto[], option: SortOption) {
    let sortedDesigns = [...designs];
    if (option === SortOption.EditedRecent) {
      sortedDesigns = designs.sort(function(a, b) {
        return new Date(b.updatedDate!).getTime() - new Date(a.updatedDate!).getTime();
      })
    } else if (option === SortOption.EditedRecentReverse) {
      sortedDesigns = designs.sort(function(a, b) {
        return new Date(a.updatedDate!).getTime() - new Date(b.updatedDate!).getTime();
      })
    } else if (option === SortOption.NameAZ) {
      sortedDesigns = designs.sort(function(a, b) {
        return ((a.name ?? "").replace(/\s/g, '')).localeCompare((b.name ?? "").replace(/\s/g, ''), 'en', { numeric: true });
      });
    } else if (option === SortOption.NameZA) {
      sortedDesigns = designs.sort(function(a, b) {
        return ((b.name ?? "").replace(/\s/g, '')).localeCompare((a.name ?? "").replace(/\s/g, ''), 'en', { numeric: true });
      });
    }
    return sortedDesigns;
  }

  function sortDesigns(option: SortOption) {
    let sortedDesigns = getSortedDesigns(designs, option);
    setCurrentSort(option);
    setDesigns([...sortedDesigns]);
    setDesignSortCookie(option);
  }

  const CreateFolderButton = (
    <Button
      className={'create-fld-btn secondary'}
      onClick={() => setCreateFolderModal(true)}
    >
      <PlusOutlined/> New Folder
    </Button>
  );

  const NoDesignsTile = (
    <div className={searchKey !== "" ? "hidden" : ""}>
      <p className={"no-data"}>
        No
        <br />
        Designs
        <br /> to Show
      </p>
    </div>
  )

  return (
    <div className={`designs page ${isProSubscription(member) ? 'dashboard-pro' : ''}`}>
      {/* <div className="mobile-search-cats">
        <SearchCategories/>
      </div> */}

      {/* {!activeFolder && <HomeBanner />} */}
      {/*!isFreeUser(member) && !activeFolder && <DisplayBanner />*/}

      {!activeFolder && <div className="carousels-content">
        {canSeeBrandCarousel && <BrandTemplateCarousel onLoaded={setHasBrandTemplates} />}
        {canSeeDesignCarousel &&
          <DesignCarousel products={AllProducts} isPro={isProSubscription(member)} hideBrandManagement={hasBrandTemplates} />}
        {/*!showIntegrationBanner && <PartnersCarousel />*/}
      </div>}

      <div className="saved-designs-content">
        <header className={`${!activeFolder ? !canSeeBrandCarousel && !canSeeDesignCarousel ? 'margin-top-none' : 'margin-top' : 'margin-top-half'}`}>
          {activeFolder && <div className={"folder-breadcrumb"}>
            <span className={"lk"} onClick={() => clearFolder(true)}>Saved Designs</span>
            {breadcrumbs.map((bc) => (
              <span>
                <span className={"rt-arw"}><RightOutlined/></span>
                <span className={"lk"} onClick={() => onFolderClick(bc)}>{bc.name}</span>
              </span>
            ))}
            <span>
              <span className={"rt-arw"}><RightOutlined/></span>
              <b>{activeFolder.name}</b>
            </span>
          </div>}
          <h3 className={"folder-name"}>
            {!activeFolder && <span>Saved Designs</span>}
            {(!mobile && !activeFolder && folders.length === 0) && !member.updateDrd && <span className="create-first-fld">{CreateFolderButton}</span>}
            {activeFolder &&
            <div>
              {!isRenamingFolder && (
              <div className={"edit-name"} onClick={(ev) => startRenamingFolder(ev)}>
                <div>{folderName || activeFolder?.name}</div>
                <Button type={"link"}>
                  <EditOutlined />
                </Button>
              </div>
              )}
              <div className={`editing-name ${isRenamingFolder ? "show" : ""}`}>
                <Input
                  ref={renameInputRef}
                  value={folderName}
                  onChange={(ev) => setFolderName(ev.target.value)}
                  onBlur={renameFolder}
                />
              </div>
            </div>}
            <div className="sort-filter">
              <div className="sort-filter-dropdowns">
                {!mobile ?
                <Dropdown
                  className={""}
                  open={isFilterMenuOpen}
                  overlay={
                    <FilterDesignsMenu
                      designs={designs}
                      activeFolder={activeFolder}
                      setDesigns={setDesigns}
                      currentFilter={currentFilter}
                      setCurrentFilter={setCurrentFilter}
                      mobile={mobile}
                      isOpen={isFilterMenuOpen}
                      closeMenu={() => setFilterMenuOpen(false)}
                    />
                  }
                >
                  <Tooltip placement="bottom" title="Filter by category">
                    <div className={`filter-dd ${isFilterMenuOpen ? 'open' : ''}`} onClick={() => setFilterMenuOpen(true)}>
                      Category
                      <DownOutlined/>
                    </div>
                  </Tooltip>
                </Dropdown>
                :
                <>
                  <div className={`filter-dd ${isFilterMenuOpen ? 'open' : ''}`} onClick={() => setFilterMenuOpen(true)}>
                    Category
                    <DownOutlined/>
                  </div>
                  <Drawer
                    placement={"bottom"}
                    open={isFilterMenuOpen}
                    className={`mobile-bottom-menu`}
                    height={"80vh"}
                    maskClosable={true}
                    onClose={() => setFilterMenuOpen(false)}
                    closable={false}
                    zIndex={1001}
                  >
                    <FilterDesignsMenu
                      designs={designs}
                      activeFolder={activeFolder}
                      setDesigns={setDesigns}
                      currentFilter={currentFilter}
                      setCurrentFilter={setCurrentFilter}
                      mobile={mobile}
                      isOpen={isFilterMenuOpen}
                      closeMenu={() => setFilterMenuOpen(false)}
                    />
                  </Drawer>
                </>
                }
                {!mobile ?
                <Dropdown
                  className={""}
                  open={isSortMenuOpen}
                  overlay={
                    <SortDesignsMenu
                      currentSort={currentSort}
                      sortDesigns={sortDesigns}
                      mobile={mobile}
                      closeMenu={() => setSortMenuOpen(false)}
                    />
                  }
                >
                  <Tooltip placement="bottom" title="Sort by">
                    <div className={`sort-dd ${isSortMenuOpen ? 'open' : ''}`} onClick={() => setSortMenuOpen(true)}>
                      {currentSort === SortOption.EditedRecent && <>Recently Edited</>}
                      {currentSort === SortOption.EditedRecentReverse && <>Oldest Edited</>}
                      {currentSort === SortOption.NameAZ && <>Alphabetical (A-Z)</>}
                      {currentSort === SortOption.NameZA && <>Alphabetical (Z-A)</>}
                      <DownOutlined/>
                    </div>
                  </Tooltip>
                </Dropdown>
                :
                <>
                  <div className={`sort-dd ${isSortMenuOpen ? 'open' : ''}`} onClick={() => setSortMenuOpen(true)}>
                    {currentSort === SortOption.EditedRecent && <>Recently Edited</>}
                    {currentSort === SortOption.EditedRecentReverse && <>Oldest Edited</>}
                    {currentSort === SortOption.NameAZ && <>Alphabetical (A-Z)</>}
                    {currentSort === SortOption.NameZA && <>Alphabetical (Z-A)</>}
                    <DownOutlined/>
                  </div>
                  <Drawer
                    placement={"bottom"}
                    open={isSortMenuOpen}
                    className={`mobile-bottom-menu`}
                    height={"330px"}
                    maskClosable={true}
                    onClose={() => setSortMenuOpen(false)}
                    closable={false}
                    zIndex={1001}
                  >
                    <SortDesignsMenu
                      currentSort={currentSort}
                      sortDesigns={sortDesigns}
                      mobile={mobile}
                      closeMenu={() => setSortMenuOpen(false)}
                    />
                  </Drawer>
                </>
                }
              </div>
            </div>
          </h3>

          <div className={"search-box search-mobile"}>
            <Input
              placeholder={"Search files"}
              onChange={(ev) => onSearch(ev.target.value)}
              value={searchKey}
            />
            <SearchOutlined />
            {searchKey.length > 0 && !hasSearchResults && (
              <p className={"nd"}>We couldn't find any matching results.</p>
            )}
          </div>

          <div className={"search-box search-desktop"}>
            <Input
              placeholder={"Search files"}
              onChange={(ev) => onSearch(ev.target.value)}
              value={searchKey}
            />
            <SearchOutlined />
            {searchKey.length > 0 && !hasSearchResults && (
              <p className={"nd"}>We couldn't find any matching results.</p>
            )}
          </div>
        </header>


        {(mobile || activeFolder || folders.length !== 0) &&
        <section className={`folders ${(searchKey.length > 0 && !hasSearchResults) ? 'hidden' : ''}`}>
          {<h4 style={{visibility: activeFolder || folders.length === 0 ? 'hidden' : 'visible'}}>Folders</h4>}
          {!activeFolder && !isFoldersExpanded && folders.length > 0 &&
          <span className={'fld-collapse-btn'} onClick={() => toggleExpandFolders(true)}><DownOutlined/></span>}
          {!activeFolder && isFoldersExpanded &&  folders.length > 0 &&
          <span className={'fld-collapse-btn'} onClick={() => toggleExpandFolders(false)}><UpOutlined/></span>}
          {CreateFolderButton}
          {folders.length !== 0 &&
          <ul className={`folders-list ${!isFoldersExpanded ? 'collapsed' : ''}`}>
            {shownFolders.map((it) => (
              <li key={it.id}>
                <FolderButton
                  folder={it}
                  active={it.id === activeFolder?.id}
                  onClick={onFolderClick}
                  deleteFolder={onDeleteFolderClick}
                  moveToFolder={onMoveFolderToFolderClick}
                  designs={designs}
                  folderThumbs={folderThumbs}
                  folderNameExists={folderNameExists}
                  afterFolderRename={afterFolderRename}
                  isMobile={mobile}
                />
              </li>
            ))}
          </ul>}
        </section>}

        {isLoading && <DesignsLoading />}

        {!isLoading && designs.filter((it) => it.visible).length === 0 && activeFolder && searchKey.length === 0 && shownFolders.length === 0 && !currentFilter &&
          <div className={"empty-folder-placeholder"}>
            <FolderOutlined/>
            <h3>This folder is currently empty</h3>
            <div className={"create-desc"}>Create a new design or move an existing design here.</div>
            {!mobile &&
            <Button size={'large'} type={'primary'} onClick={() => setCreateDesignModal(true)}>
              Create a design
            </Button>}
            {mobile &&
            <div>
              <Button size={'large'} type={'primary'} onClick={() => setCreateDesignModal(true)}>
                Create a design
              </Button>
              <Drawer
                placement={"bottom"}
                visible={isCreateDesignModal}
                title={"Create a design"}
                closeIcon={<DownOutlined/>}
                onClose={() => setCreateDesignModal(false)}
                className={"create-design-modal create-design-mobile"}
                height={"600px"}
              >
                <CreateDesignMenuContent products={AllProducts} activeFolder={activeFolder} />
              </Drawer>
            </div>}
          </div>
        }

        {!isLoading && (
          <section className={"designs"} id={"savedDesigns"} style={{marginTop: `${activeFolder && shownFolders.length === 0 ? '55px' : ''}`}}>
            {designs.filter((it) => it.visible).length === 0 && !activeFolder && NoDesignsTile}
            {!isLoading && designs.filter((it) => it.visible).length === 0 && activeFolder && searchKey.length === 0 && shownFolders.length === 0 && currentFilter &&
            NoDesignsTile}

            <ul>
              {designs
                .filter((it) => it.visible)
                .map((it) => (
                  <DesignCard
                    key={it.id}
                    design={it}
                    hasRemoveFolderOption={activeFolder !== null}
                    onOptionClick={onDesignOptionClick}
                    onSelect={onDesignSelect}
                    onUpdate={onDesignUpdate}
                    selectMode={selected.length > 0}
                    isSelected={selected.includes(it)}
                    reloadDesigns={reloadDesigns}
                    scrollToDesignsTop={scrollToDesignsTop}
                    isSingleUserAcc={isSingleUserAcc}
                    getDesignThumb={getDesignThumb}
                    hasUsers={hasUsers}
                  />
                ))}
              </ul>
          </section>
        )}
      </div>

      {selected.length > 0 && (
        <DesignBatchBar
          selected={selected}
          onOrganizeClick={onOrganizeClick}
          onDeleteClick={onDeleteClick}
          onCombineClick={onCombineClick}
          onCancelClick={onCancelClick}
          selectedPageCount={selectedPageCount}
          isCombineLoading={isCombineLoading}
        />
      )}

      {!mobile &&
      <MoveToFolderModal
        ids={selectedIds}
        folders={folders}
        activeFolder={activeFolder}
        isVisible={isMoveToFolderModal}
        onCloseMovedToFolder={onMoveToFolderClose}
        onCloseMovedToSavedDesigns={onMoveToFolderSavedDesignsClose}
        onCloseMovedFolderToFolder={onMoveToFolderMovedFolderClose}
        onCreateNewFolder={onCreateNewFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
      />}

      {mobile &&
      <MoveToFolderDrawer
        ids={selectedIds}
        folders={folders}
        activeFolder={activeFolder}
        isVisible={isMoveToFolderModal}
        onBack={() => setMoveToFolderModal(false)}
        onCloseMovedToFolder={onMoveToFolderClose}
        onCloseMovedToSavedDesigns={onMoveToFolderSavedDesignsClose}
        onCloseMovedFolderToFolder={onMoveToFolderMovedFolderClose}
        onCreateNewFolder={onCreateNewFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
      />}

      {!mobile &&
      <CreateFolderModal
        ids={selectedIds}
        isVisible={isCreateFolderModal}
        onClose={onCreateFolderModalClose}
        folderToMove={folderToMove}
        folderNameExists={folderNameExists}
        activeFolder={activeFolder}
      />}

      {mobile &&
      <CreateFolderDrawer
        ids={selectedIds}
        isVisible={isCreateFolderModal}
        onClose={onCreateFolderModalClose}
        folderToMove={folderToMove}
        folderNameExists={folderNameExists}
        activeFolder={activeFolder}
      />}

      <RemoveDesignFromFolderModal
        isVisible={isRemoveDesignFromFolderModal}
        folder={activeFolder}
        design={activeDesign}
        onClose={onRemoveDesignFromFolderSuccess}
      />

      <DeleteFolderModal
        folder={folderToMove}
        isVisible={isDeleteFolderModal}
        onClose={onDeleteFolderSuccess}
      />

      <ChangeLocationModal
        id={activeDesign.id ?? ""}
        design={activeDesign}
        isVisible={isChangeLocationModal}
        onClose={onChangeLocationModalClose}
      />

      <ConfirmDeleteModal
        ids={selectedIds}
        design={activeDesign}
        designs={selected}
        isVisible={isConfirmDeleteModal}
        onClose={onConfirmDeleteModalClose}
      />

      <OldBrowserModal
        isVisible={isOldBrowserModal}
        onClose={() => setOldBrowserModal(false)}
      />

      {!mobile &&
      <CreateDesignModal
        products={AllProducts}
        isVisible={isCreateDesignModal}
        onClose={() => setCreateDesignModal(false)}
        activeFolder={activeFolder}
      />}

      <PopmenuWelcomeModal visible={isPopmenuWelcomeModal} onClose={() => setPopmenuWelcomeModal(false)}/>
    </div>
  );
}
